export const fetchApplicationFeatures = async (apps) => {
    const promises = apps.map(a => fetchSingleApplicationFeatures(a));
    const features = await Promise.all(promises);
    return features.reduce((acc, feature) => {
        acc[feature.name] = feature;
        return acc;
    }, {});
};
export const fetchSingleApplicationFeatures = async (app) => {
    const url = `https://feature-flags.decentraland.org/${app}.json`;
    const response = await fetch(url, { credentials: 'include', mode: 'cors' });
    const json = await response.json();
    return {
        name: app,
        flags: json.flags,
        variants: json.variants
    };
};
//# sourceMappingURL=utils.js.map